import { API_BASE_URL } from "./config.js";
import { useState, useEffect } from "react";
import axios from "axios";
import authHeader from "../services/auth-header.js";

const useAxiosFetch = (url, timeout) => {
  const [data, setData] = useState();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(false); // New state for refresh

  const refetch = () => {
    setRefreshTrigger(!refreshTrigger);  // Toggles the state of refreshTrigger
  };

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    axios
      .get(API_BASE_URL + url, {
        cancelToken: source.token,
        timeout: timeout,
        headers: authHeader(),
      })
      .then((a) => {
        if (!unmounted) {
          // @ts-ignore
          setData(a.data);
          setLoading(false);
        }
      })
      .catch(function (e) {
        if (!unmounted) {
          setError(true);
          setErrorMessage(e.message);
          setLoading(false);
          if (axios.isCancel(e)) {
            console.log(`request cancelled:${e.message}`);
          } else {
            // logging out user if 500 error
            if (e.response && e.response.status === 500) {
                localStorage.clear();
                window.location.reload();
            }
          }
        }
      });
    return function () {
      unmounted = true;
      source.cancel("Cancelling in cleanup");
    };
  }, [url, timeout, refreshTrigger]);  // Added refreshTrigger to the dependencies

  return { data, loading, refetch, error, errorMessage};  // Added refetch to the return object
};

export default useAxiosFetch;